const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/ECheckinForm.tsx';
import { forwardRef } from 'react';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import EinwArzt from 'App/config/usz/eCheckin/sections/EinwArzt';
import HausArzt from 'App/config/usz/eCheckin/sections/HausArzt';
import KontaktPerson from 'App/config/usz/eCheckin/sections/KontaktPerson';
import Kosten from 'App/config/usz/eCheckin/sections/Kosten';
import PersAngaben from 'App/config/usz/eCheckin/sections/PersAngaben';
import Versicherung from 'App/config/usz/eCheckin/sections/Versicherung';
import textMap from 'App/config/usz/eCheckin/translations';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <KontaktPerson path="kontakt" title={textMap.kontakt} />
            <HausArzt path="hausArzt" title={textMap.hausArzt} />
            <EinwArzt path="einwArzt" title={textMap.einwArzt} />
            <Versicherung path="versicherung" title={textMap.versicherungLabel} />
            <Kosten path="behandlungsvereinbarung" title={textMap.kosten} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
